module.exports = __webpack_public_path__ + "img/hr-transition-4.02d47205.png";